import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'

import { TrainingComponent } from './training.component'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: TrainingComponent,
        canActivate: [MetaGuard],
        data: {
          segment: SegmentTagMap.TRAINING_HOME,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          noTopScroll: true,
          meta: {
            title: 'meta_training_page_title',
            description: 'meta_training_page_description',
            'og:type': 'meta_default_type'
          }
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class TrainingRoutingModule {}
